import {Modal} from './modal';
import {$$} from './util/$$';

type ModalData = {
    title: string;
    body: string;
    theme: string;
};

const FLOWCHART_SELECTOR: string = '.js-flowchart';
const MODAL_TRIGGER_SELECTOR: string = '.js-flowchart__modal-trigger';

function modalTriggers(container: HTMLElement): void {
    $$(MODAL_TRIGGER_SELECTOR, container).forEach(
        (element: HTMLElement): void => {
            element.addEventListener('click', (): void => {
                const data: ModalData = JSON.parse(
                    <string>element.getAttribute('data-modal'),
                );

                Modal.open(data.title, data.body, data.theme);
            });
        },
    );
}

export function flowchart(): void {
    $$(FLOWCHART_SELECTOR).forEach((element: HTMLElement): void => {
        modalTriggers(element);
    });
}
